import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { KButtonType, KKcgButtonSubType } from 'ng-k-button';
import { GlobalLoadingService } from 'src/app/services/global-loading.service';
import { NihlOutlineExposureService } from 'src/app/services/nihl-outline-exposure.service';
import { KInputType} from 'ng-k-form';
import { ClaimsService } from 'src/app/services/claims.service';
import { OauthPlusService } from 'src/app/services/oauth-plus.service';
@Component({
  selector: 'app-outline-exposure',
  templateUrl: './outline-exposure.component.html',
  styleUrls: ['./outline-exposure.component.scss']
})
export class OutlineExposureComponent implements OnInit {
  KButtonType = KButtonType;
  KKcgButtonSubType = KKcgButtonSubType;
  public claimId: any;
  public taskId: any;
  public outlineExposureForm: any =  {};
  public showStage1: boolean = true;
  hideStage2: boolean = true; 
  public employmentListData = [];
  public currentEmployerData = [];
  public isSubmitted = false;
  public dynamicNumberInput: any = KInputType['number'];
  public currentExposureId: any = '';

  public successText!: string;
  public errorText!: string;
  public displaySuccess: boolean = false;
  public displayError: boolean = false;
  public timeout!: number;
  public notionalExposureList: {label: string, value: any}[] = [];
  public customData: any;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private _auth: OauthPlusService,
    private loaderService: GlobalLoadingService,
    private nihlOutlineExposureService: NihlOutlineExposureService,
    private fb: FormBuilder,
    private claimsService: ClaimsService
  ) {
    this.outlineExposureForm = fb.group({
      employerName: ['',Validators.required],
      notionalExposure: ['', Validators.required]
    });
   }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      if (!this.isUrlEncoded(params['claimId'])) {
        this.claimId = decodeURIComponent(params['claimId']);
      } else {
        this.claimId = params['claimId'];
      }
  
      if (!this.isUrlEncoded(params['taskId'])) {
        this.taskId = decodeURIComponent(params['taskId']);
      } else {
        this.taskId = params['taskId'];
      }

      if (params['exposureId']) {
        this.currentExposureId = params['exposureId']
      }
    });

    this._auth.$whenUserLoaded.subscribe(data=> {
      if(data) {
        this.getEmploymentList(this.claimId);
        this.notionalExposureDropdownList()

        if (this.currentExposureId) {
          this.getExposureById()
        }
      }
    });

    this.getWorkflowOverview(this.claimId);
  }

  public getWorkflowOverview(claimID: any) {
    const thisObj = this;
    const requestParam: any = {};
    requestParam.claimId = claimID ? claimID : null;
    this.loaderService.startLoadingIndicator('getWorkflowOverview');

    thisObj.claimsService.getWorkflowOverview(requestParam).subscribe(result => {
      if (result.status === 'Success') {
        this.loaderService.stopLoadingIndicator('getWorkflowOverview');

        this.customData = {
          claimId : this.claimId,
          taskId: this.taskId,
          claimantName : result.data.meta.claimant.claimantName,
          medicalConditionLabel: 'NIHL',
          medicalConditionValue: 'nihl'
        };
      }
    },
      err => {
        console.log(err.error);
      });
  }

  public notionalExposureDropdownList() {
    let tempList = ['Clinical Medico-legal','Defendant Medico-legal','Occupational Hygiene', 'Hospital'];
    for(let i=85;i<126;i++) {
      this.notionalExposureList.push({label: ''+i, value: i });
    }
  }

  public getExposureById() {
    const thisObj = this;
    const requestParam: any = {};
    requestParam.claimId = this.claimId? this.claimId : null;
    requestParam.taskId = this.taskId? this.taskId : null;
    requestParam.actionName = 'exposure_view_by_id';
    requestParam.payload = {
      "id":this.currentExposureId
    };
    this.loaderService.startLoadingIndicator('getExposureById');
    thisObj.nihlOutlineExposureService.getExposureList(requestParam).subscribe(result => {
      if (result.status === 'Success') {
        this.loaderService.stopLoadingIndicator('getExposureById');
        this.hideStage2 = false;
        this.currentEmployerData = result.data[0].employer;
        this.outlineExposureForm.patchValue({
          employerName : result.data[0].employer.employer,
          notionalExposure: result.data[0].notionalExposure
        });
      }
    });
}

  public getEmploymentList(claimId: any) {
    const thisObj = this;
    const requestParam: any = {};
    requestParam.claimId = claimId? claimId : null;
    this.loaderService.startLoadingIndicator('getEmploymentList');
    
    thisObj.nihlOutlineExposureService.getEmploymentList(requestParam).subscribe(result => {
      if (result.status === 'Success') {
        this.loaderService.stopLoadingIndicator('getEmploymentList');
        this.employmentListData = result.data;
      }  
    },
    err => {
      console.log('err')
      console.log(err.error);
      this.loaderService.stopLoadingIndicator('getEmploymentList');
    }); 
  }

  public isUrlEncoded(str: string): boolean {
    try {
      return str !== decodeURIComponent(str);
    } catch (e) {
      return false;
    }
  }

  public goToPage() {
    this.router.navigate(['/nihl/investigation/outline-exposure/',this.claimId, this.taskId]);
  }

  public editEmployer() {
    this.router.navigate(['claimForm',encodeURIComponent(this.claimId)]);
  }

  public onEmployerNameClick(employer: any) {
    if(employer) {
      this.currentEmployerData = employer;
      this.hideStage2 = false;
    }
  }

  public saveOutlineExposureForm(form: any) {
    this.isSubmitted = true;
    if(form.status == 'VALID'){
      const thisObj = this;
      const requestParam: any = {};
      this.loaderService.startLoadingIndicator('saveOutlineExposureForm');
      requestParam.claimId = this.claimId? this.claimId : null;
      requestParam.taskId = this.taskId? this.taskId : null;
      if (this.currentExposureId) {
        requestParam.actionName = 'edit_nihl_exposure';
        requestParam.payload = {
          "id" : this.currentExposureId,
          "employer" : this.currentEmployerData,
          "notionalExposure": form.controls.notionalExposure.value,
        };
      } else {
        requestParam.actionName = 'add_nihl_exposure';
        requestParam.payload = {
          "employer" : this.currentEmployerData,
          "notionalExposure": form.controls.notionalExposure.value,
        };
      }

      thisObj.claimsService.postWorkflowActivity(requestParam).subscribe(result => {
        if (result.status === 'Success') {
          this.loaderService.stopLoadingIndicator('saveOutlineExposureForm');
          if (result.data.isValid) {
            if (this.currentExposureId != '')
            { 
              this.successText = 'Exposure edited successfully';
            } else {
              this.successText = 'Exposure added successfully';
            }
            this.showMessage('success', 2000);
            setTimeout(() => {
              this.router.navigate(['nihl/investigation/outline-exposure',this.claimId, this.taskId])
            },2020);
          } else {
            this.errorText = result.data.errors;
            this.showMessage('error', 2000);
          }          
        }
      }); 
    }
  }

  

  public showMessage(msgType: any, timeout: any) {
    this.displaySuccess = false;
    this.displaySuccess = false;
    if ( msgType === 'success' ) {
      this.displaySuccess = true;
    }
    if ( msgType === 'error') {
      this.displayError = true;
    }
    if ( timeout ) {
      this.timeout = timeout;
    }
  }

  /**
   * convenience getter for easy access to form fields
   */
  get f() { 
    return this.outlineExposureForm.controls; 
  }

}
